import axios from "axios";

export default {
    state:{
        infocredito:{},
        abonos:[],
        editabono:{}
    },
    mutations:{
        setAllAbonos(state,items){
            state.abonos=items
        },
        setInfoCredito(state,data){
            state.infocredito=data
        },
        setStateEditabono(state,item){
            state.editabono=item
        }
    },
    actions:{
        async setAbonos({commit,rootState,getters},idcredito){

            try {
                const { data } = await axios.get(`${rootState.urlapi}/abonos/${idcredito}`,getters.getTokenUser);
                commit("setAllAbonos",data)
            } catch (error) {
                commit("setAllAbonos",[])
                console.error(error)
            }
        },
        setInfoCredito({commit},item){
            const infocredito = {
                idcredito : item.idfactura,
                numero : item.numero,
                serie : item.serie,
                fechacredito : item.fecha,
                cliente:item.idpersona.nombre,
                totalcredito:item.total

            }

            commit("setInfoCredito",infocredito)

        },
        setEditAbono({commit},data){
            commit("setStateEditabono",data)
        }
    },
    getters:{
        getAbonos(state){
            const itemsfiltrados =  state.abonos.filter(elemento=>elemento.estado=="Activo")
            return itemsfiltrados
        },
        getInfoCredito(state){
            return state.infocredito
        },
        getTotalAbonado(state){
            if(state.abonos.length<1) return 0.00
        
            const itemsfiltrados =  state.abonos.filter(elemento=>elemento.estado=="Activo")
            return itemsfiltrados.reduce(
                (acumulado,siguiente) => parseFloat(acumulado) + parseFloat(siguiente.monto),
                0 //Establecemos el valor inicial
            ) 
        }
    }
}